import { c as _c } from "react/compiler-runtime";
import { FaroTable } from "@components/common/faro-table/faro-table";
import { FaroTableColumnVisibilityMenu } from "@components/common/faro-table/faro-table-column-visibility-menu";
import { useMembersColumns } from "@components/table/members/members-column/use-members-columns";
import { TEAM_MEMBERS_SORT_BY_MAP } from "@components/table/members/members-sort-constants";
import { MEMBERS_TABLE_COLUMN_LABELS } from "@components/table/members/members-table-constants";
import { getTeamMembersSortByFromGridSortModel } from "@components/table/members/members-table-utils";
import { useHandleColumnOrderChange } from "@hooks/use-handle-column-order-change";
import { useAppDispatch } from "@store/store-helper";
import { setTableType } from "@store/table/table-slice";
import { API_MEMBERS_PER_REQUEST } from "@store/teams/teams-slice-utils";
import { TableType } from "@utils/track-event/track-event-list";
import { useCallback, useEffect } from "react";
/**
 * A table component specifically for displaying team members with pagination
 */
export function TeamMembersTable(t0) {
  const $ = _c(24);
  const {
    companyId,
    members,
    isLoading,
    team,
    bulkActionButtons,
    shouldHideCheckbox: t1,
    loadMoreItems,
    hasMoreItems,
    sortBy,
    setSortBy,
    teamMembersTotalCount
  } = t0;
  const shouldHideCheckbox = t1 === undefined ? false : t1;
  const dispatch = useAppDispatch();
  let t2;
  let t3;
  if ($[0] !== dispatch) {
    t2 = () => {
      dispatch(setTableType(TableType.teamMembers));
    };
    t3 = [dispatch];
    $[0] = dispatch;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== companyId || $[4] !== team) {
    t4 = {
      companyId,
      tableSubject: "team",
      team
    };
    $[3] = companyId;
    $[4] = team;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const columns = useMembersColumns(t4);
  const handleColumnOrderChange = useHandleColumnOrderChange(TableType.teamMembers);
  const t5 = TEAM_MEMBERS_SORT_BY_MAP[sortBy];
  let t6;
  if ($[6] !== t5) {
    t6 = [t5];
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const sortModel = t6;
  let t7;
  if ($[8] !== setSortBy) {
    t7 = newModel => {
      const newSortBy = getTeamMembersSortByFromGridSortModel(newModel);
      setSortBy(newSortBy);
    };
    $[8] = setSortBy;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const handleSortModelChange = t7;
  let t8;
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FaroTableColumnVisibilityMenu tableType={TableType.teamMembers} labelsMap={MEMBERS_TABLE_COLUMN_LABELS} disabledColumns={["user"]} />;
    t9 = {
      "& .MuiDataGrid-columnHeader:hover .drag-handle": {
        visibility: "visible",
        display: "flex"
      },
      "& .MuiDataGrid-columnHeaderTitleContainerContent": {
        width: "100%"
      }
    };
    $[10] = t8;
    $[11] = t9;
  } else {
    t8 = $[10];
    t9 = $[11];
  }
  let t10;
  if ($[12] !== bulkActionButtons || $[13] !== columns || $[14] !== handleColumnOrderChange || $[15] !== handleSortModelChange || $[16] !== hasMoreItems || $[17] !== isLoading || $[18] !== loadMoreItems || $[19] !== members || $[20] !== shouldHideCheckbox || $[21] !== sortModel || $[22] !== teamMembersTotalCount) {
    t10 = <FaroTable entities={members} uniqueIdKey="identity" columns={columns} isLoading={isLoading} pageSize={API_MEMBERS_PER_REQUEST} hasMoreItems={hasMoreItems} totalCount={teamMembersTotalCount} onNextPage={loadMoreItems} bulkActionButtons={bulkActionButtons} shouldHideCheckbox={shouldHideCheckbox} sortModel={sortModel} onSortModelChange={handleSortModelChange} onColumnOrderChange={handleColumnOrderChange} tableType={TableType.teamMembers} paginationMode="server" sortTrackingSubject="Team Member" filterMenuTrigger={t8} sx={t9} />;
    $[12] = bulkActionButtons;
    $[13] = columns;
    $[14] = handleColumnOrderChange;
    $[15] = handleSortModelChange;
    $[16] = hasMoreItems;
    $[17] = isLoading;
    $[18] = loadMoreItems;
    $[19] = members;
    $[20] = shouldHideCheckbox;
    $[21] = sortModel;
    $[22] = teamMembersTotalCount;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}